/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// Interface can't directly have constants but this module can
export const ASYNC_QUEUE_VIEW_FULL = "fullView";
export const ASYNC_QUEUE_VIEW_UPDATE = "viewUpdate";
//# sourceMappingURL=StreamingRPCService.js.map
